import { Row, Col } from "react-bootstrap";
import "./cvtemplates.css";
import { useState } from "react";
import Slider from "react-slick";
import { useNavigate, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CVTemplate1 from "./CVtemplate1/components/CVImg";
import CVTemplate2 from "./CVtemplate2/components/CVImg2";
import CVTemplate3 from "./CVtemplate3/components/CVImg3";
import CVTemplate4 from "./CVtemplate4/components/CVImg4";
import CVTemplate5 from "./CVtemplate5/components/CVImg5";
import { useSelector } from "react-redux";
import {
  useGetCvFormQuery,
  useUpdateCvTemplateMutation,
  useLazyGetEmployeeByUserIdQuery,
} from "../../features/user/userApiSlice";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
const CVTemplates = () => {
  const { name } = useSelector((state) => state.user);
  const location = useLocation();
  const { data: cvDataRes, isFetching } = useGetCvFormQuery(name?._id, {
    skip: !name?._id,
    refetchOnMountOrArgChange: true,
  });
  // Prefer fresh API data; fall back to CV passed from post/update navigate state
  const cvdata = cvDataRes?.cvform || location.state?.cvform;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    button: true,
  };

  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const [updateCvTemplate] = useUpdateCvTemplateMutation();
  const [triggerGetEmployee] = useLazyGetEmployeeByUserIdQuery();

  const Selecttemplate = async () => {
    try {
      const res = await updateCvTemplate({ userId: name?._id, templateIndex: currentIndex }).unwrap();
      if (res) {
        SuccessNotify("CV Template Selected");

        try {
          const employeeRes = await triggerGetEmployee(name?._id).unwrap();
          if (employeeRes?.success === true) {
            navigate(`/view-application/${employeeRes?.data?.Employee?._id}`);
          } else {
            navigate("/create-job-app");
          }
        } catch (employeeErr) {
          // If employee is not found (404), navigate to create job app
          navigate("/create-job-app");
        }
      }
    } catch (err) {
      console.error(err);
      FailedNotify("Something went wrong");
    }
  };
  return (
    <Row className="cv-templates-page">
      <div className="screenHeight">
        <Row>
          <Col md={2} lg={2} className="d-flex justify-content-center cv-select-col">
            <div className="d-flex w-100 justify-content-center">
              <div className="leftSideCenter d-flex justify-content-center">
                <div className="CVtexts h-100 d-flex flex-column  justify-content-center ">
                  <h6>Select CV</h6>
                  <h5>Template</h5>
                  <div>
                    <button
                      className="m-0 btn-color"
                      onClick={() => Selecttemplate()}
                    >
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={10} lg={10}>
            <Row>
              <Col md={2} lg={2} className="pe-0 cv-line-col">
                <hr className="cvcenterline " />
              </Col>
              <Col md={10} lg={10} className="mx-auto cv-slider-col">
                <div className="cv-slider-wrap">
                  {!cvdata && isFetching ? (
                    <h5 className="text-center text-primary mt-5">Loading CV...</h5>
                  ) : (
                    <Slider
                      key={cvdata?._id || "cv-loading"}
                      {...settings}
                      afterChange={(newIndex) => {
                        setCurrentIndex(newIndex);
                      }}
                    >
                      <div className="cv-slide">
                        <CVTemplate1 cvdata={cvdata} />
                      </div>
                      <div className="cv-slide">
                        <CVTemplate2 cvdata={cvdata} />
                      </div>
                      <div className="cv-slide">
                        <CVTemplate3 cvdata={cvdata} />
                      </div>
                      <div className="cv-slide">
                        <CVTemplate4 cvdata={cvdata} />
                      </div>
                      <div className="cv-slide">
                        <CVTemplate5 cvdata={cvdata} />
                      </div>
                    </Slider>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
};
export default CVTemplates;
